// Road-related helper functions for cleaner code and better maintainability

/**
 * Creates a road update object with consistent structure
 */
export const createRoadUpdate = (road: string, isFromMap: boolean = false) => ({
  road,
  roadFromMap: isFromMap,
});
